import React, { useEffect } from 'react';

interface StatusResponse {
  page: {
    id: string;
    name: string;
    url: string;
    time_zone: string;
    updated_at: string;
  };
  status: {
    indicator: string;
    description: string;
  };
}

const useFetchStatus = () => {
  const [status, setStatus] = React.useState<StatusResponse | null>(null);
  const [statusIsFetching, setStatusIsFetching] = React.useState<boolean>(false);
  const [statusIsError, setStatusIsError] = React.useState<boolean>(false);

  useEffect(() => {
    setStatusIsFetching(true);
    let isMounted = true;

    async function fetchData() {
      try {
        const response = await fetch('https://trustfull.statuspage.io/api/v2/status.json');
        const data: StatusResponse = await response.json();
        if (isMounted) {
          setStatus(data);
        }
      } catch {
        if (isMounted) {
          setStatusIsError(true);
        }
      } finally {
        if (isMounted) {
          setStatusIsFetching(false);
        }
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  return { status, statusIsFetching, statusIsError };
};

export default useFetchStatus;
